import * as React from 'react';
import SortableItemsTable from "./SortableItemsTable";

export default class StringSortableTable extends SortableItemsTable<string> {


	renderHeaderBody() {
		return (
			<th>Sidebar item</th>
		)
	}

	renderRowBody(item: string) {
		return (
			<td>{item}</td>
		)
	};

	itemToId(item: string): string {
		return item;
	}
}

